function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * dd-elements.ts 10.3.1
 * Copyright (c) 2021 Alain Dumesny - see GridStack root license
 */
import { DDResizable } from './dd-resizable';
import { DDDraggable } from './dd-draggable';
import { DDDroppable } from './dd-droppable';
export var DDElement = /*#__PURE__*/function () {
  function DDElement(el) {
    _classCallCheck(this, DDElement);
    this.el = el;
  }
  return _createClass(DDElement, [{
    key: "on",
    value: function on(eventName, callback) {
      if (this.ddDraggable && ['drag', 'dragstart', 'dragstop'].indexOf(eventName) > -1) {
        this.ddDraggable.on(eventName, callback);
      } else if (this.ddDroppable && ['drop', 'dropover', 'dropout'].indexOf(eventName) > -1) {
        this.ddDroppable.on(eventName, callback);
      } else if (this.ddResizable && ['resizestart', 'resize', 'resizestop'].indexOf(eventName) > -1) {
        this.ddResizable.on(eventName, callback);
      }
      return this;
    }
  }, {
    key: "off",
    value: function off(eventName) {
      if (this.ddDraggable && ['drag', 'dragstart', 'dragstop'].indexOf(eventName) > -1) {
        this.ddDraggable.off(eventName);
      } else if (this.ddDroppable && ['drop', 'dropover', 'dropout'].indexOf(eventName) > -1) {
        this.ddDroppable.off(eventName);
      } else if (this.ddResizable && ['resizestart', 'resize', 'resizestop'].indexOf(eventName) > -1) {
        this.ddResizable.off(eventName);
      }
      return this;
    }
  }, {
    key: "setupDraggable",
    value: function setupDraggable(opts) {
      if (!this.ddDraggable) {
        this.ddDraggable = new DDDraggable(this.el, opts);
      } else {
        this.ddDraggable.updateOption(opts);
      }
      return this;
    }
  }, {
    key: "cleanDraggable",
    value: function cleanDraggable() {
      if (this.ddDraggable) {
        this.ddDraggable.destroy();
        delete this.ddDraggable;
      }
      return this;
    }
  }, {
    key: "setupResizable",
    value: function setupResizable(opts) {
      if (!this.ddResizable) {
        this.ddResizable = new DDResizable(this.el, opts);
      } else {
        this.ddResizable.updateOption(opts);
      }
      return this;
    }
  }, {
    key: "cleanResizable",
    value: function cleanResizable() {
      if (this.ddResizable) {
        this.ddResizable.destroy();
        delete this.ddResizable;
      }
      return this;
    }
  }, {
    key: "setupDroppable",
    value: function setupDroppable(opts) {
      if (!this.ddDroppable) {
        this.ddDroppable = new DDDroppable(this.el, opts);
      } else {
        this.ddDroppable.updateOption(opts);
      }
      return this;
    }
  }, {
    key: "cleanDroppable",
    value: function cleanDroppable() {
      if (this.ddDroppable) {
        this.ddDroppable.destroy();
        delete this.ddDroppable;
      }
      return this;
    }
  }], [{
    key: "init",
    value: function init(el) {
      if (!el.ddElement) {
        el.ddElement = new DDElement(el);
      }
      return el.ddElement;
    }
  }]);
}();